module.exports = __webpack_public_path__ + "media/images/icons/flags/KM-ccae0abaf676081877c41f265402c5c0.svg";